module.exports = __webpack_public_path__ + "static/media/back-two.78424ae0.png";